import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { selectUser } from "../features/userSlice";
import db from "../firebase";
import "./PaymentSuccessScreen.css";
function PaymentSuccessScreen() {
 const user = useSelector(selectUser);
  const history = useHistory();

  useEffect(() => {
    const parms = window.location.search.substring(1);
    function parse_query_string(query) {
      var vars = query.split("&");
      var query_string = {};
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
          query_string[key] = decodeURIComponent(value);
          // If second entry with this name
        } else if (typeof query_string[key] === "string") {
          var arr = [query_string[key], decodeURIComponent(value)];
          query_string[key] = arr;
          // If third or later entry with this name
        } else {
          query_string[key].push(decodeURIComponent(value));
        }
      }
      return query_string;
    }
    const userPaymentData = parse_query_string(parms);
    const oid = userPaymentData.oid;
    const amt = userPaymentData.amt;
    const refid = userPaymentData.refId;

    const path = "https://uat.esewa.com.np/epay/transrec";
    const params = {
      amt: amt,
      rid: refid,
      pid: oid,
      scd: "EPAYTEST", // default for all my trangit
      };
    async function post() {
      var form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", path);

      for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
      document.body.appendChild(form);
      form.submit();
      };
      function planBuySuccess() {
      /// use this code after ayments was sucessed
       db
        .collection("users")
        .doc(user.uid)
        .set({
          userName: user.email,
          DimondPlan:  oid.search("Dimond") !== -1 ? "active" : "none",
          GoldPlan:  oid.search("Gold") !== -1 ? "active" : "none",
          PremiumPlan:  oid.search("Premium") !== -1 ? "active" : "none",
          timeStamp: Date(),
        })
        .then((result) => {
          ///
          // user sucessfully buy plan
            post();
        })
        .catch((error) => {
          alert(`Fail to buy plan for, error: ${error.massage}`);
        });
      };
      planBuySuccess();
  }, []);
    
    ////////////failll do somethisg
    
    /////////////////////////

  return (
    <div className="paymentsuccessscreen">
      <h5>INJOY,YOURSELF.</h5>
      <h1>SUCCESSFULLY BUY PLAN.</h1>
      <br />
      <button onClick={() => {history.push('/')}}>CLICK TO CONTINUE</button>
      <h4>THANK Q.</h4>
    </div>
  );
}

export default PaymentSuccessScreen;
